import { Pipe, PipeTransform } from '@angular/core';
import { EntityId } from '@shared/core/types';

@Pipe({
  name: 'isCrm1EducationService',
})
export class IsCrm1EducationServicePipe implements PipeTransform {
  transform(serviceId: EntityId): boolean {
    return serviceId < 10000000;
  }
}
